import { render, staticRenderFns } from "./TimezoneTable.vue?vue&type=template&id=480a6ae8&scoped=true"
import script from "./TimezoneTable.vue?vue&type=script&lang=js"
export * from "./TimezoneTable.vue?vue&type=script&lang=js"
import style0 from "./TimezoneTable.vue?vue&type=style&index=0&id=480a6ae8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a6ae8",
  null
  
)

export default component.exports